// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// Why each part of the Floor Plan screen has no data, stated once and shown
// wherever that data would have gone.
//
// This screen used to run on seeded geometry and seeded plant readouts. Those
// seeds are gone: a drawing that looks like a real building, and plant numbers
// that look like real telemetry, are the two things on this screen most likely
// to be mistaken for fact. What is left is the design with its gaps named.

/**
 * Plan geometry. Not "no endpoint yet" — there is no contract that *could*
 * serve it as things stand. The ontology models `hasLocation` / `isLocationOf`
 * / `containsEquipment`, so the twin knows which room a unit belongs to, but it
 * carries no coordinate, dimension or extent for anything. A scale drawing
 * needs geometry from CAD/BIM, and nothing publishes it.
 */
export const PLAN_GEOMETRY_UNPUBLISHED =
  'no contract carries plan geometry — the Digital Twin models which room ' +
  'contains a unit, but no coordinates, dimensions or extents';

/**
 * Plant readouts. Unlike geometry these *are* modelled — `ChillerState`,
 * `UPSTypeState`, `Zone_Air_Temperature_Sensor` and friends all exist in the
 * ontology — so this is a wiring gap rather than a modelling one.
 */
export const CRITICAL_SYSTEMS_UNPUBLISHED =
  'no endpoint serves plant readouts — the ontology models the state, nothing ' +
  'publishes it for a site';

/**
 * The facility-vs-HVAC comparison is drawn from two of the readouts above, so
 * it is missing for the same reason and says so in its own words.
 */
export const LOAD_COMPARISON_UNPUBLISHED = 'no endpoint serves total facility or HVAC load';

/**
 * The one gap with an existing feed behind it. HVAC faults are not a new
 * source: the contract types them as AEM alarm rows filtered to the site's HVAC
 * equipment. Binding them is a wiring job against `alarmApiService`, not a
 * missing contract — recorded here so the difference stays visible.
 */
export const HVAC_FAULTS_UNBOUND =
  'Fault history is not shown here yet. Open Alarms to see HVAC faults for this site.';
